<template>
  <div class="chart-item">
    <div class="report-header">
      <h1 class="report-title textMainColor">{{ $t('Positions') }}</h1>
    </div>
    <div class="content-wrapper">
      <div class="preloader new-preloader" v-if="isLoading">
        <lottie-animation
            ref="preloader"
            :animationData="require('@/assets/img/Loader.json')"
            :loop="true"
            :autoPlay="true"
            :speed="1"
        />
      </div>
      <template v-else-if="optionsHistoryLength">
        <highcharts
            :updateArgs="updateArgs"
            :options="chartOptionsFundingRateHistory"
        />
      </template>
      <div v-if="!isLoading && isDataEmpty" class="holder-not-logged-text report-empty-wrap">
        <div class="report-empty-list">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.1351 5.89334C41.0418 4.8 39.1484 5.54667 39.1484 7.06667V16.3733C39.1484 20.2667 42.4551 23.4933 46.4818 23.4933C49.0151 23.52 52.5351 23.52 55.5484 23.52C57.0684 23.52 57.8684 21.7333 56.8018 20.6667C52.9618 16.8 46.0818 9.84 42.1351 5.89334Z" fill="#92939C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M46.9613 27.1733H54.668C56.1346 27.1733 57.3346 28.3733 57.3346 29.84V39.6441C55.2687 38.1884 52.7495 37.3333 50.0315 37.3333C43.0218 37.3333 37.3346 43.0205 37.3346 50.0302C37.3346 53.365 38.6218 56.4005 40.7262 58.6666H21.5213C13.308 58.6666 6.66797 53.3333 6.66797 43.8133V20.1866C6.66797 10.6666 13.308 5.33331 21.5213 5.33331H32.828C34.2946 5.33331 35.4946 6.53331 35.4946 7.99998V15.7066C35.4946 22.0266 40.6413 27.1733 46.9613 27.1733ZM57.3346 43.755V43.8133C57.3346 52.1992 52.1825 57.3365 45.3411 58.4415C42.3948 56.7941 40.4015 53.6436 40.4015 50.0302C40.4015 44.7143 44.7156 40.4002 50.0315 40.4002C52.9509 40.4002 55.5682 41.7013 57.3346 43.755ZM20.0013 47.3333H30.668C31.7613 47.3333 32.668 46.4266 32.668 45.3333C32.668 44.24 31.7613 43.3333 30.668 43.3333H20.0013C18.908 43.3333 18.0013 44.24 18.0013 45.3333C18.0013 46.4266 18.908 47.3333 20.0013 47.3333ZM20.0013 36.6666H36.0013C37.0946 36.6666 38.0013 35.76 38.0013 34.6666C38.0013 33.5733 37.0946 32.6666 36.0013 32.6666H20.0013C18.908 32.6666 18.0013 33.5733 18.0013 34.6666C18.0013 35.76 18.908 36.6666 20.0013 36.6666Z" fill="#92939C"/>
            <path d="M59.9855 57.2476L58.0636 55.3257C59.0655 53.8127 59.6584 51.993 59.6584 50.0302C59.6584 44.7143 55.3443 40.4002 50.0284 40.4002C44.7125 40.4002 40.3984 44.7143 40.3984 50.0302C40.3984 55.3461 44.7125 59.6602 50.0284 59.6602C51.9912 59.6602 53.7905 59.0672 55.3239 58.0654L57.2458 59.9873C57.6343 60.3758 58.125 60.5598 58.6361 60.5598C59.1473 60.5598 59.638 60.3758 60.0264 59.9873C60.742 59.2513 60.742 58.0245 59.9855 57.2476Z" fill="#92939C"/>
          </svg>
          <p class="secondary-text holder-not-logged-text">{{ $t('No records found') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import { mapActions } from 'vuex';
import moment from 'moment';
import { Chart } from 'highcharts-vue';

export default {
  name: 'FundingRateHistory',
  data() {
    return {
      updateArgs: [true, true, true],
      isLoading: false,
      isDataEmpty: false,
      fundingRateHistoryData: [
      {
        name: 'Chrome',
        y: 61.41,
        sliced: true,
        selected: true
      }, {
        name: 'Internet Explorer',
        y: 11.84
      }, {
        name: 'Firefox',
        y: 10.85
      }, {
        name: 'Edge',
        y: 4.67
      }, {
        name: 'Safari',
        y: 4.18
      }, {
        name: 'Sogou Explorer',
        y: 1.64
      }, {
        name: 'Opera',
        y: 1.6
      }, {
        name: 'QQ',
        y: 1.2
      }, {
        name: 'Other',
        y: 2.61
      }
    ],
      symbol: 'btc_usdt',
      dimension: 'DAYS_7',
      type: null,
      chartOptionsFundingRateHistory: {
        chart: {
          plotBackgroundColor: 'var(--v-pieChartBackgroundColor-base)',
          backgroundColor: 'var(--v-pieChartBackgroundColor-base)',
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
        },
        title: {
          text: '',
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.name}<br> {point.percentage:.2f} %<br> {point.value:.2f}',
              color: 'var(--v-pieChartTextColor-base)',
              style: {
                stroke: 'none',
                fontStyle: 'normal',
                fontFamily: 'Play',
                fontWeight: '700',
                fontSize: '13px',
                lineHeight: '14px',
              }
            },
            borderColor: 'transparent',
            plotOptions: '#333',
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          type: 'pie',
          name: '',
          innerSize: '50%',
          colorByPoint: true,
          data: []
        }]
      },
    };
  },
  components: {
    highcharts: Chart,
    LottieAnimation,
  },
  computed: {
    optionsHistoryLength() {
      return this.chartOptionsFundingRateHistory.series[0].data.length
    },
  },
  methods: {
    ...mapActions({
      getFundingRateHistoryData: 'tradingData/getFundingRateHistory',
      getAccountInfo: 'orders/getAccountInfo',
    }),

    max(list) {
      return list.reduce((a, b) => a > b ? a : b);
    },

    min(list) {
      return list.reduce((a, b) => a < b ? a : b);
    },

    transformChartItemName(name) {
      return name.split('_').join('').toUpperCase();
    },

    getFundingRateHistory() {
      this.fundingRateHistoryDataTime = [];
      // this.fundingRateHistory = [];
      this.getFundingRateHistoryData({
        symbol: this.symbol,
        timeScope: this.dimension,
      }).then(res => {
        let response = res.data;

        if (response.length) {
          // this.fundingRateHistoryData = body.content;
          // this.count = body.totalPages;
          // this.pageSize = body.size;

          response.content.forEach(el => {
            this.fundingRateHistory.push(el.fundingRate);
            this.fundingRateHistoryDataTime.push(Date.parse(el.createdAt));
          });

          this.chartOptionsFundingRateHistory.xAxis[0].categories = this.fundingRateHistoryDataTime;
          this.chartOptionsFundingRateHistory.yAxis[0].min = this.min(this.fundingRateHistory);
          this.chartOptionsFundingRateHistory.yAxis[0].max = this.max(this.fundingRateHistory);
          this.chartOptionsFundingRateHistory.series[0].data = this.fundingRateHistory;
          this.chartOptionsFundingRateHistory.series[0].name = this.symbol;
        }
      });
    },

    getAccountInfoData() {
      this.isLoading = true;
      this.getAccountInfo().then((data) => {
        this.chartOptionsFundingRateHistory.series[0].data = [];

        data.positions.forEach(el => {
          const name = this.transformChartItemName(el.symbol);

          if (el.amount > 0) {
            this.chartOptionsFundingRateHistory.series[0].data.push({
              name,
              y: Math.abs(el.amount) * el.markPrice,
              value: Math.abs(el.amount) * el.markPrice,
              color: `rgba(27, ${176 + el.amount * 20}, 176)`,
            })
          } else if (el.amount < 0) {
            this.chartOptionsFundingRateHistory.series[0].data.push({
              name,
              y: Math.abs(el.amount) * el.markPrice,
              value: Math.abs(el.amount) * el.markPrice,
              color: `rgba(255, ${115 + el.amount * 20}, 55)`,
            })
          }
        })

        this.isLoading = false;

        const dataArray = data.positions.filter(position => position.amount !== 0);

        if(!dataArray.length) {
          this.isDataEmpty = true
        }
      })
    },
  },

  mounted() {
    this.getAccountInfoData();
    this.page = this.$route.query.page || 1;
    // this.getFundingRateHistory();
  }
};
</script>

<style scoped>
.chart-item-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.content-wrapper {
  position: relative;
  min-height: 500px;
}

.chart-item-table {
  margin-top: 55px;
  border-bottom: 1px solid var(--v-loginDropduwnHoverBackgroundColor-base);
}

.chart-item-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.chart-item-table tr {
  margin-bottom: 15px;
}

.chart-item-table thead {
  border-top: 1px solid var(--v-loginDropduwnHoverBackgroundColor-base);
  border-bottom: 1px solid var(--v-loginDropduwnHoverBackgroundColor-base);
  text-align: left;
  color: var(--v-tableSecondaryColor-base);
}

.chart-item-table th {
  padding: 12px 0;
}

.chart-item-table tbody tr {
  font-size: 12px;
  border-bottom: 30px solid transparent;
  color: var(--v-selectColor-base);
}

.chart-item-table th:not(:last-of-type),
.chart-item-table td:not(:last-of-type) {
  width: 40%;
}


.chart-item-table th:last-of-type,
.chart-item-table td:last-of-type {
  text-align: center;
}

.chart-item-table tbody td:first-child {
  padding-right: 10px;
  font-size: 14px;
  font-weight: 600;
}

.chart-item-table tbody td:nth-child(3n):after {
  content: " %";
  color: var(--v-tableSecondaryColor-base);
}

.preloader-overlay {
  background-color: transparent;
}

.holder-not-logged-text {
  color: #A4A5AF;
}

@media (max-width: 500px) {
  .chart-item-container {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
